<template>
  <v-layout justify-center>
    <v-bottom-sheet v-model="sheet" inset>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="#FFF" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-email-send</v-icon>
        </v-btn>
      </template>

      <v-sheet height="500px">
        <div class="df pt-5 pl-5 pr-5">
          <h3 v-if="configCadastradas">
            <v-icon color="#444">mdi-email-send</v-icon>
            Enviar pedido em cotação por e-mail
          </h3>
          <h3 v-else>
            <v-icon color="#444">mdi-lock</v-icon>
            Envio de e-mail não configurado
          </h3>

          <v-spacer></v-spacer>

          <v-btn v-if="configCadastradas" @click="dialogConfgs = true" icon>
            <v-icon>mdi-cogs</v-icon>
          </v-btn>

          <v-btn text color="#FA5858" @click="fechar()">
            <v-icon>mdi-delete</v-icon>
            <span>descartar</span>
          </v-btn>

          <v-btn v-if="configCadastradas" color="primary" @click="enviar()" class="ml-3">
            <v-icon>mdi-send</v-icon>
            <span class="ml-2">Enviar</span>
          </v-btn>
          <v-btn v-else class="ml-3" @click="dialogConfgs = true" color="error">
            <span>Configurar e-mail</span>
            <v-icon color="white">mdi-cogs</v-icon>
          </v-btn>
        </div>

        <div class="df ml-5 mr-5 mt-4">
          <v-autocomplete
            v-model="email.destinatarios"
            :items="email.destinatarios"
            :search-input.sync="searchEmail"
            outlined
            small-chips
            label="Para"
            multiple
            clearable
            hide-no-data
            hide-selected
            append-icon=""
            :error-messages="destinatariosErrors"
            @blur="searchEmail = searchEmail ? searchEmail.concat(' ') : ''"
            @keyup.enter="searchEmail = searchEmail ? searchEmail.concat(' ') : ''"
            :disabled="!configCadastradas"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeEmail(data.item)"
              >
                {{ data.item }}
              </v-chip>
            </template>
          </v-autocomplete>
        </div>

        <div class="df ml-5 mr-5">
          <v-text-field
            v-model="email.assunto"
            label="Assunto"
            placeholder="Informe um título"
            clearable
            outlined
            :error-messages="assuntoErrors"
            @input="$v.email.assunto.$touch()"
            @blur="$v.email.assunto.$touch()"
            :disabled="!configCadastradas"
          ></v-text-field>
        </div>

        <div class="df ml-5 mr-5">
          <v-flex xs12>
            <v-textarea
              v-model="email.mensagem"
              label="Mensagem"
              placeholder="Escreva a sua mensagem aqui..."
              outlined
              :error-messages="mensagemErrors"
              @input="$v.email.mensagem.$touch()"
              @blur="$v.email.mensagem.$touch()"
              :disabled="!configCadastradas"
            ></v-textarea>
          </v-flex>
        </div>

        <div class="df ml-5 mr-5 -mt-5" style="color: #444">
          <v-icon style="font-size: 20px">mdi-paperclip</v-icon>
          <h5>
            relatório do pedido #{{ pedidoSelecionado.idpedido }} em anexo
          </h5>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <dialog-error
      :dialog="dialogError"
      :errors="['Erro ao enviar e-mail. Tente novamente.']"
      @fechar="dialogError = false"
    ></dialog-error>

    <cadastroConfigs
      :dialog="dialogConfgs"
      :configCadastradas="configCadastradas"
      @fechar-dialog="dialogConfgs = false"
      @configs-cadastradas="configCadastradas = true"
    ></cadastroConfigs>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
import { required, email } from "vuelidate/lib/validators"

import MailAPI from "../../../api/mail.js"

import dialogError from "../../utils/DialogError.vue"
import cadastroConfigs from './CadastroConfigsSMTP.vue'

export default {
  name: 'EnviarEmailCotacao.vue',
  components: { dialogError, cadastroConfigs },
  props: ["pedidoSelecionado"],
  data () {
    return {
      sheet: false,
      dialogError: false,
      configCadastradas: false,
      dialogConfgs: false,
      email: {
        destinatarios: [],
        assunto: '',
        mensagem: '',
      },
      searchEmail: ''
    }
  },
  validations: {
    searchEmail: {
      email
    },
    email: {
      destinatarios: {
        required,
      },
      assunto: {
        required,
      },
      mensagem: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    destinatariosErrors: function () {
      const errors = []

      if (this.searchEmail) {
        const emailJaAdd = this.email.destinatarios.includes(this.searchEmail)
        if (emailJaAdd) errors.push("Email já adicionado.")

        const emailValido = email(this.searchEmail)
        if (!emailValido) errors.push("Email Inválido.")
      }

      if (!this.$v.email.destinatarios.$dirty) return errors
      !this.$v.email.destinatarios.required && errors.push("Campo Obrigatório.")

      return errors
    },
    assuntoErrors: function () {
      const errors = []
      if (!this.$v.email.assunto.$dirty) return errors;
      !this.$v.email.assunto.required && errors.push("Campo Obrigatório.")
      return errors
    },
    mensagemErrors: function () {
      const errors = []
      if (!this.$v.email.mensagem.$dirty) return errors
      !this.$v.email.mensagem.required && errors.push("Campo Obrigatório.")
      return errors
    }
  },
  watch: {
    sheet () {
      if (this.sheet) {
        this.verificarConfigsMailUsuario()
      }
    },
    searchEmail () {
      if (!this.searchEmail || this.searchEmail.length < 6) {
        return 0
      }

      const separadores = [' ', ',', ';']
      const ultCaractere = this.searchEmail.substring(this.searchEmail.length - 1)

      if (separadores.includes(ultCaractere)) {
        const novoEmail = this.searchEmail.substring(0, this.searchEmail.length - 1).trim()

        const emailValido = email(novoEmail)

        if (emailValido && !this.email.destinatarios.includes(novoEmail)) {
          this.email.destinatarios.push(novoEmail)
          this.searchEmail = ''
        } else {
          this.searchEmail = this.searchEmail.trim()
        }
      } else {
        this.searchEmail = this.searchEmail.trim()
      }
    }
  },
  methods: {
    removeEmail (item) {
      const index = this.email.destinatarios.indexOf(item)
      if (index >= 0) {
        this.email.destinatarios.splice(index, 1)
      }
    },
    verificarConfigsMailUsuario() {
      if (!this.configs) {
        const headers = this.Helpers.iniciarRequisicao()
        this.$store.dispatch("loading/addRequisicao",
          MailAPI.verificarConfigsMailUsuario(headers).then((response) => {
            const { token, configs } = response.data
            localStorage.setItem("token", token)
            this.configCadastradas = configs
          })
        )
      }
    },
    fechar: function () {
      this.$v.$reset()
      this.sheet = false
      this.email = {
        destinatarios: [],
        assunto: "",
        mensagem: "",
      }
      this.searchEmail = ''
    },
    enviar: function () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao()

        const params = {
          grupo: this.grupoCompra,
          email: this.email,
          pedido: this.pedidoSelecionado.idpedido,
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          MailAPI.enviarEmailCotacao(headers, params).then((response) => {
            const { token, resultado } = response.data
            localStorage.setItem("token", token)

            if (resultado.status === 200) {
              this.fechar()
            } else {
              this.dialogError = true
            }
          })
        )
      }
    }
  }
}
</script>

<style scoped>
.-mt-5 {
  margin-top: -10px;
}
</style>
